import {Part} from "../part";
import {wallsThumbnail} from "../assets";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import Baseboard from "../subparts/globals/baseboard";
// import CeilingHighlights from "../subparts/globals/ceilingHighlights";
import CeilingLights from "../subparts/globals/ceilingLights";
import GlobalShadow from "../subparts/globals/globalShadow";
import Decor1 from "../subparts/globals/decor1";
import Decor2 from "../subparts/globals/decor2";
import Decor3 from "../subparts/globals/decor3";

export default class Globals extends Part {
  static id = 'Globals';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Globals';
    this.partThumbnail = wallsThumbnail;

    // related items
    this.baseboard = null;
    this.ceilingHighlights = null;
    this.ceilingLights = null;
    this.globalShadow = null;
    this.decor1 = null;
    this.decor2 = null;
    this.decor3 = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Baseboard":
        relatedItemName = "baseboard";
        RelatedItemClass = Baseboard;
        break;
      // case "Ceiling Highlight":
      //   relatedItemName = "ceilingHighlights";
      //   RelatedItemClass = CeilingHighlights;
      //   break;
      case "Ceiling Lights":
        relatedItemName = "ceilingLights";
        RelatedItemClass = CeilingLights;
        break;
      case "Global Shadow":
        relatedItemName = "globalShadow";
        RelatedItemClass = GlobalShadow;
        break;
      case "Decor":
        if (dbFeature.displayName.includes("Part2")) {
          relatedItemName = "decor2";
          RelatedItemClass = Decor2;
        } else if (dbFeature.displayName.includes("Island")) {
          relatedItemName = "decor3";
          RelatedItemClass = Decor3;
        } else {
          relatedItemName = "decor1";
          RelatedItemClass = Decor1;
        }
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Globals', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}